/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationCloudTarget extends models.AllocationServiceAccountTarget {
    constructor() {
        super();
        this.setDiscriminator("AllocationCloudTarget");
    }

    getFixupPrototypeFunction() { return AllocationCloudTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationCloudTarget>): AllocationCloudTarget {
        let obj = Object.assign(new AllocationCloudTarget(), model);
        AllocationCloudTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationCloudTarget>): AllocationCloudTarget {
        if (!model) return null;
        return AllocationCloudTarget.newInstance(<AllocationCloudTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationCloudTarget) {
        if (!obj) return;

        models.AllocationCloudTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationCloudTarget): boolean {
        if (models.AllocationServiceAccountTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AllocationCloudTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
